/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import {hideHeader} from "../constants/functions";

export default class extends Component{
    getInitialProps(){
        return {
            ruta: {
                slug: "",
                imagen: {
                    thumbnail: "/img/brujula_oficial_gris.png"
                },
                nombre: ""
            }
        }
    }
    componentDidMount(){
        hideHeader();
    }
    render(){
        let ruta = this.props.ruta;
        let imagen = '/img/brujula_oficial_gris.png';
        if(ruta.imagen){
            imagen = ruta.imagen.thumbnail;
        }
        if(ruta) {

            let MAX_CHARS = 250;

            let alrededores = ruta.alrededores.replace(/(<([^>]+)>)/,"");

            if(alrededores.length>MAX_CHARS){
                alrededores = alrededores.substr(0,MAX_CHARS)+" &hellip;";
            }

            return (
                <div className="poi-info media">
                    <div className="media-left">
                        <div className="thumbnail">
                            <Link to={`/ruta/${ruta.slug}`}>
                                <img src={imagen} alt={ruta.nombre}/>
                            </Link>
                        </div>
                    </div>
                    <div className="media-body">
                        <Link to={`/ruta/${ruta.slug}`}>
                            <h4 className="media-heading">{ruta.nombre}</h4>
                        </Link>
                        <p dangerouslySetInnerHTML={{__html: alrededores}}/>
                        <p className="pull-right">
                            <Link to={`/ruta/${ruta.slug}`} className="btn btn-default">
                                Ver Ruta
                            </Link>
                        </p>
                    </div>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Ruta.js